import type {
  ClaimDetailSheet,
  ClaimEligibilityCta,
  ClaimReasonData,
  ClaimReasonNode,
  ViewDetailData,
} from "../types";

export enum ModalActionId {
  VIEW_TRAVELLER_DETAIL = "VIEW_TRAVELLER_DETAIL",
  OPEN_CLAIM_REASON = "OPEN_CLAIM_REASON",
  CHECK_ELIGIBILITY = "CHECK_ELIGIBILITY",
  OPEN_CLAIM_DETAIL_BOTTOM_SHEET = "OPEN_CLAIM_DETAIL_BOTTOM_SHEET",
}

export type ModalPayloadMap = {
  [ModalActionId.VIEW_TRAVELLER_DETAIL]: ViewDetailData;
  [ModalActionId.OPEN_CLAIM_REASON]: {
    reasonData: ClaimReasonData;
    onSelectNode: (node: ClaimReasonNode) => void;
  };
  [ModalActionId.CHECK_ELIGIBILITY]: {
    data?: NonNullable<ClaimEligibilityCta["action"]>["data"];
  };
  [ModalActionId.OPEN_CLAIM_DETAIL_BOTTOM_SHEET]: ClaimDetailSheet;
};

export type ModalState = {
  activeModal: ModalActionId | null;
  payload: ModalPayloadMap[ModalActionId] | null;
};

export type ModalOpenAction<K extends ModalActionId = ModalActionId> = {
  type: "OPEN";
  actionId: K;
  payload: ModalPayloadMap[K];
};

export type ModalCloseAction = { type: "CLOSE" };

export type ModalAction = ModalOpenAction | ModalCloseAction;
